import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Subscription} from '../../subscription/subscription.model';
import {AutorunComponent} from '@myshared/autorun.component';
import {Model} from '../../app.model';
import {PhonenumberService} from '../../phonenumber/phonenumber.service';
import {BlockNumber, PhonenumberPrice} from '../../phonenumber/phonenumber.model';
import {HttpClient} from '@angular/common/http';
import {PC_ONE_PHONE_NUMBERS} from "../select-product/product.model";
import { PhonenumberType } from 'src/app/workflow/workflow-phonenumbers/workflow-phonenumbers.component';
import {CustomerService} from '../../customer/customer.service';

@Component({
    selector: 'app-select-phonenumber-type',
    templateUrl: './select-phonenumber-type.component.html',
    standalone: false
})
export class SelectPhonenumberTypeComponent extends AutorunComponent implements OnInit {

  @Input() subscription: Subscription;
  @Input() trunkNumbers: BlockNumber[];
  @Output() selected: EventEmitter<PhonenumberType> = new EventEmitter<PhonenumberType>();

  public monthlyPrice = 0.2;
  public setupPrice = 2;

  public usedInSubscription = 0;

  public newNumberLimitReached: boolean = false;

  constructor(private m: Model,
              private phonenumberService: PhonenumberService,
              private customerService: CustomerService,
              private http: HttpClient) {
    super();
  }

  ngOnInit() {
    this.autorun(() => {
      this.usedInSubscription = this.phonenumberService
        .getPhonenumberUsedInSubscriptionSize(this.subscription.appliance_id, this.m.phonenumber.blocks);
    });
    this.http.get<{pc_one_new_number_surplus: PhonenumberPrice[], pc_one_number_surplus: PhonenumberPrice[]}>
    ('/services/products/cloud').subscribe(r => {
      this.monthlyPrice = r.pc_one_number_surplus[0]?.list_price;
      this.setupPrice = r.pc_one_new_number_surplus[0]?.list_price;
    });    
  }

  selectNew() {
    this.newNumberLimitReached = this.checkCanBuyNewNumber();
    if (!this.newNumberLimitReached)
      this.selected.emit('new');
  }

  selectPort() {
    this.selected.emit('port');
  }

  selectLocInd() {
    this.newNumberLimitReached = this.checkCanBuyNewNumber();
    if (!this.newNumberLimitReached)
      this.selected.emit('loc-independent');
  }

  checkCanBuyNewNumber() {
    const acquiredNumbers = this.m.phonenumber.blocks.filter((block) => block.origin === "acquired" && block.appliance.appliance_id === this.subscription.appliance_id);
    let count = 0
    acquiredNumbers.forEach(element => {
      count += element.numbers.length
    });
    if (!this.subscription.trunkUnlimitAcquireNumbers && this.subscription.trunkEnvironment.maxAllowedAcquiredNumbers !== -1 && count >= this.subscription.trunkEnvironment.maxAllowedAcquiredNumbers){
      return true;
    } 
    return false;
  }

  get includedInSubscription(): number {
    return +this.subscription.users * PC_ONE_PHONE_NUMBERS;
  }

}
